<!-- Header -->
<h3 mat-dialog-title translate>
    {{attachment.FileID == -1 ? 'Add' : 'Edit'}} Attachment
</h3>

<!-- Body -->
<mat-dialog-content>
    <form>
        <tyl-form-field *ngIf="V10" label="Attachment Name"
            style="width: 300px">
            <input matInput
                #nameField
                id="attachmentNameField"
                name="attachment name"
                [(ngModel)]="attachment.MyFileName"
                [required]="true"
                maxlength="35" />
        </tyl-form-field>
        <tyl-checkbox *ngIf="V10" [(checked)]="attachment.AllowParentToView"
            id="allowParentToViewCheckboxV10"
            name="allow parent to view"
            translate>
            Visible to Parents/Students
        </tyl-checkbox>
        <br />
        <tyl-form-field label="Description" 
            hint="{{V10 ? 75 : 100 - (attachment.Description ? attachment.Description.length : 0)}} characters left"
            style="width: 600px">
            <input matInput
                #descriptionField
                id="descriptionField"
                name="description"
                placeholder="{{'Description' | translate}}"
                [(ngModel)]="attachment.Description"
                [maxlength]="V10 ? 75 : 100"
                [required]="!V10" />
        </tyl-form-field>
        <br>
        <add-file [(fileString)]="attachment.MyFile"
            [(fileType)]="attachment.FileType"
            [(fileName)]="attachment.OriginalFileName"
            [(fileExtension)]="attachment.FileExtension"></add-file>
        <br>
        <tyl-checkbox *ngIf="!V10" [(checked)]="attachment.AllowParentToView"
            id="allowParentToViewCheckboxV9"
            name="allow parent to view"
            translate>
            Visible to Parents/Students
        </tyl-checkbox>
    </form>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
    <div class="footerRight">
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="save.png" label="Save" (clickEvent)="save()"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancel()"></tyl-button>
    </div>
</mat-dialog-actions>
